<template>
  <v-container v-show="$auth.ready()">
    <v-form ref="form">
      <v-select :items="audienceTypes" v-model="selectedAudienceType" label="Audience" outlined />
      <v-text-field v-if="selectedAudienceType==='SPECIFIC_EMAIL_ADDRESS'" label="Email" v-model="message.to" counter="255" hint="Enter target email address" :rules="emailRules" outlined></v-text-field>
      <v-text-field label="Subject" v-model="message.subject" counter="255" hint="Enter message subject" :rules="textRules" outlined></v-text-field>
      <v-card outlined>
        <v-card-text>Message (Header and Footer is attached by the server)
          <quill-editor v-model="message.body"/>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="resetForm">Reset</v-btn>
          <v-spacer/>
          <v-btn @click="showPreview = true">Preview</v-btn>
          <v-btn color="primary" @click="sendMessage">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <br>
    <v-snackbar v-model="showSnackbar">
      {{snackBarMessage}}
      <template v-slot:action="{ attrs }">
        <v-btn color="teal" text v-bind="attrs" @click="showSnackbar=false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="showPreview" persistent max-width="800">
      <v-card>
        <v-card-text>
          <br>
          <p>Hi [username],</p>
          <div v-html="message.body"> </div>
<!--          <p>Happy Sailing,</p>-->
<!--          <p>-->
<!--            <em>Your eSail team</em>-->
<!--          </p>-->
          <br>
          <div>
            <p style="font-family:Arial,Helvetica,sans-serif;font-size:14px"><br>
              <a href="https://www.esailyachtsimulator.com/" target="_blank">
                <img src="https://www.esailyachtsimulator.com/wp-content/uploads/2018/11/esail-logo-e1544715402327.png" title="eSail" alt="" width="250" height="84" border="0" data-image-whitelisted="" class="CToWUd">
              </a>
              <br>
              <br>
            </p>
            <p>
              <font size="-2" face="Arial,sans-serif" color="#666666">
                <font size="-1">
                  <a href="http://www.esailyachtsimulator.com" target="_blank" data-saferedirecturl="https://www.google.com/url?q=http://www.esailyachtsimulator.com&amp;source=gmail&amp;ust=1617202006159000&amp;usg=AFQjCNG-7_caOKf8nA3_hhUu4gYdWae9JQ">www.esailyachtsimulator.com</a>
                </font><br>
              </font>
            </p>
            <p>
              <font size="-2" face="Arial,sans-serif" color="#666666">©
                eSail Ltd. &nbsp;&nbsp; eSail® is a registered trademark.
              </font>
              <font size="-2" face="Arial,sans-serif" color="#666666"><br>
                [ Disclaimer ... ]
              </font>
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="showPreview = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import {eSailServerAuth} from "@/plugins/axios";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {

  name: "Notifications",
  components: {
    quillEditor
  },
  data: () => ({
    audienceTypes: [],
    selectedAudienceType: null,
    message: {
      subject: "",
      body: "",
    },
    showPreview: false,
    showSnackbar: false,
    snackBarMessage: null,
    textRules: [v => v.length > 0 && v.length <= 255 || 'Min 1 and Max 255 characters'],
    emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid']
  }),
  mounted() {
    eSailServerAuth.get('admin/users/notification/audience-types', { headers: { Authorization: `Bearer ` + this.$auth.token() }})
      .then(response => this.audienceTypes = response.data)
  },
  methods: {
    resetForm() {
      this.selectedAudienceType = null
      this.message.subject = ""
      this.message.body = ""
    },
    sendMessage() {
      const formIsValid = this.$refs.form.validate();
      if (this.selectedAudienceType && formIsValid && this.message.body.length > 0) {
        eSailServerAuth.post('admin/users/notification?audience-type=' + this.selectedAudienceType, this.message, {headers: {Authorization: `Bearer ` + this.$auth.token()}})
            .then(() => {
              this.snackBarMessage = "Message sent!"
              this.showSnackbar = true

            })
      } else {
        this.snackBarMessage = "Please select an audience / email address and enter subject and message!";
        this.showSnackbar = true;
      }
    }
  }
}
</script>

<style scoped>

</style>